/** @file Writes world-space vertices of a rigid mesh (local vertices + deform) for one bone world matrix. */
import { invariant } from '@pose2d/std/invariant';
import type { MeshAttachmentData } from '@pose2d/core/types';
import { writeWorldPoints } from './_internal/writeWorldPoints';

/**
 * Writes 2 floats per vertex into out at offset; returns the new offset. Rigid meshes only (spec §6.7): `deform`
 * holds mesh-local offsets, 2 per vertex (null = none). Throws (invariant) for a skinned mesh.
 */
export function meshVertices(out: Float32Array, offset: number, att: MeshAttachmentData, world: Float64Array, worldOffset: number, deform: Float64Array | null): number {
  const skin = att.skin;
  invariant(skin.kind === 'rigid', 'meshVertices needs a rigid mesh (skinned meshes go through skinVertices)');
  return writeWorldPoints(out, offset, skin.vertices, deform, skin.vertices.length / 2, world, worldOffset);
}
